import { render, staticRenderFns } from "./KnowledgeBaseView.vue?vue&type=template&id=a91671b2&scoped=true&"
import script from "./KnowledgeBaseView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseView.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseView.vue?vue&type=style&index=0&id=a91671b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91671b2",
  null
  
)

export default component.exports